import React from "react";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../mock/mock";

const Testimonials = () => {
  return (
    <section className="bg-[#f5f7ff] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">
            Member Reviews
          </div>
          <h2 className="text-[#0a1a4a] text-3xl sm:text-4xl font-bold mt-3">
            What members say about Ryan
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="card-lift bg-white rounded-2xl p-8 relative">
              <Quote className="text-[#ff5a5a]/25 absolute top-6 right-6" size={44} />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={16} className="fill-[#ff5a5a] text-[#ff5a5a]" />
                ))}
              </div>
              <p className="text-[#0a1a4a]/80 text-sm leading-relaxed">{t.text}</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#0a1a4a] to-[#1c3aa8] flex items-center justify-center text-white font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-[#0a1a4a] text-sm">{t.name}</div>
                  <div className="text-[#0a1a4a]/60 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
